// Vector port of TournamentPrintableTable.js's `styles.footer` block
// (export date on the left, brand name on the right).
import { PRINT_THEME as T } from "./printTheme";
import { px2pt, px2mm, lineHeightMm, drawText, hLine } from "./pdfKit";

const FOOTER_FS = px2pt(12);
const MARGIN_TOP_MM = px2mm(24);
const PAD_TOP_MM = px2mm(12);
const LINE_H_MM = lineHeightMm(FOOTER_FS, 1.2);

export const measureFooter = () => MARGIN_TOP_MM + PAD_TOP_MM + LINE_H_MM;

export const drawFooter = (pdf, x, y, maxWidthMm) => {
    const borderY = y + MARGIN_TOP_MM;
    hLine(pdf, x, borderY, maxWidthMm, T.border, px2mm(1));
    const textY = borderY + PAD_TOP_MM;

    const dateStr = new Date().toLocaleDateString("uk-UA", { year: "numeric", month: "long", day: "numeric" });
    drawText(pdf, dateStr, x, textY, { fontSizePt: FOOTER_FS, color: T.muted });

    pdf.setFont(pdf.__pdfFontName || "PTSans", "normal");
    pdf.setFontSize(FOOTER_FS);
    const brand = "Tournaments Platform";
    const brandW = pdf.getTextWidth(brand);
    drawText(pdf, brand, x + maxWidthMm - brandW, textY, { fontSizePt: FOOTER_FS, color: T.ink });

    return textY + LINE_H_MM;
};
